function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.9773 2.40101C9.97539 2.42409 8.30808 4.07404 8.30808 6.0932C8.30808 7.69123 9.03501 8.87388 9.70424 10.1719C9.75616 10.27 9.78501 10.3969 9.78501 10.5123V12.7391H9.68116L4.13693 14.2679C3.12731 14.4929 2.40039 15.3987 2.40039 16.4313V18.6466H3.87731V19.3851C3.87731 20.6023 4.87539 21.6004 6.0927 21.6004H17.9081C19.1254 21.6004 20.1235 20.6023 20.1235 19.3851V18.6466H21.6004V16.4313C21.6004 15.3987 20.8735 14.4929 19.8639 14.2679L14.3196 12.7391H14.2158V10.5123C14.2158 10.3969 14.2446 10.27 14.2965 10.1661C14.9196 8.96619 15.5831 7.87583 15.6812 6.43934C15.8023 4.64517 14.6542 2.90292 12.8542 2.49332C12.56 2.42986 12.2658 2.39524 11.9773 2.40101ZM5.35424 18.6466H18.6465V19.3851C18.6465 19.8004 18.3235 20.1235 17.9081 20.1235H6.0927C5.67731 20.1235 5.35424 19.8004 5.35424 19.3851V18.6466Z",
  fill: "#767B87"
});

const SvgApproveSolid = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgApproveSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/approve_solid.40aa849f.svg";
export { ForwardRef as ReactComponent };